import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import FilterSwitcher from '../../../components/FilterSwitcher/FilterSwitcher';
import { memo } from 'react';

type SwitcherOptionProps = {
    value: boolean;
    label: string;
    tooltip: string;
    tooltipId: string;
    onClick: (newVal: string) => void;
    className?: string;
}

export const SwitcherOption = memo(({ className, value, label, onClick, tooltip, tooltipId }: SwitcherOptionProps) => {
    return <div className={`text-chat-options_table_row ${className}`}>
        <div
            data-place="bottom"
            data-multiline="true"
            data-effect="solid"
            data-offset="{'top': -20}"
            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240 text-chat-option-tooltip"
            data-for={tooltipId}
            data-tip={tooltip}>
            <FilterSwitcher
                labelIfTrue={label}
                labelIfFalse={label}
                offMode={true}
                minWidth="100%"
                maxWidth="100%"
                labelOnLeftSide={true}
                onClick={onClick}
                value={value} />
        </div>
        <ReactTooltip id={tooltipId} />
    </div>;
})